
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component(({
  components: {}
}))
export default class SatelliteBandSelector extends Vue {
  @Prop({ default: () => [] }) readonly bands!: string[];
  @Prop({ default: null }) readonly value!: string | null;

  internal: string | null = null;

  created() {
    this.internal = this.value;
  }

  @Watch('value')
  onValueChange(v: string | null) {
    this.internal = v;
  }

  onChange() {
    this.$emit('input', this.internal);
    this.$emit('select-band', this.internal);
  }
}
